import React from 'react'

const Ai = () => {
  return (

    <div className='skills__content'>
    <h3 className='skills__title'> Artificial Intelligence Library & some Algorithms </h3>

    <div className='skill__box'>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bx-shape-circle'></i>
                            <div>
                    <h3 className='skills__name'>PyTorch</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-shape-circle'></i>
                <div>
                    <h3 className='skills__name'>TF</h3>
                    <span className='skills__level'> </span>
                </div>
            </div>
            
            <div className='skills__data'>
            <i class='bx bx-shape-circle'></i>
                <div>
                    <h3 className='skills__name'>OpenCV</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bx-shape-circle'></i>
                <div>
                    <h3 className='skills__name'>Spark</h3>
                    <span className='skills__level'></span>
                </div>
            </div>
        </div>
        <div className='skills__group'>
            <div className='skills__data'>
            <i class='bx bxl-graphql' ></i>
                <div>
                    <h3 className='skills__name'>ANNs</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bxl-graphql' ></i>
                <div>
                    <h3 className='skills__name'>Regression</h3>
                </div>
            </div>
           
            <div className='skills__data'>
            <i class='bx bxl-graphql' ></i>
                <div>
                    <h3 className='skills__name'>CNNs</h3>
                </div>
            </div>
            <div className='skills__data'>
            <i class='bx bxl-graphql' ></i>
                <div>
                    <h3 className='skills__name'>ETC</h3>
                </div>
            </div>
            
        </div>
        
    </div>
</div>

  )
}

export default Ai